<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { site } from '../../../content'

const isScrolled = ref(false)
const isMobileMenuOpen = ref(false)

const handleScroll = () => {
  isScrolled.value = window.scrollY > 50
}

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
  document.body.style.overflow = isMobileMenuOpen.value ? 'hidden' : ''
}

const closeMobileMenu = () => {
  isMobileMenuOpen.value = false
  document.body.style.overflow = ''
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<template>
  <header :class="['header', isScrolled ? 'header--solid' : 'header--transparent']">
    <div class="container">
      <div class="header__inner">
        <a href="#top" class="header__logo">{{ site.nav.logo }}</a>

        <nav class="header__nav">
          <div class="header__links">
            <a
              v-for="item in site.nav.menu"
              :key="item.label"
              :href="item.href"
              class="header__link"
            >
              {{ item.label }}
            </a>
          </div>

          <div class="header__actions">
            <a
              v-for="link in site.nav.links"
              :key="link.label"
              :href="link.href"
              :class="link.href.startsWith('#') ? 'btn btn--primary' : 'btn btn--ghost'"
            >
              {{ link.label }}
            </a>
          </div>
        </nav>

        <button class="header__menu-btn" @click="toggleMobileMenu" aria-label="Toggle menu">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 12h18M3 6h18M3 18h18"/>
          </svg>
        </button>
      </div>
    </div>
  </header>

  <!-- Mobile Menu Overlay -->
  <div
    :class="['mobile-menu__overlay', { 'mobile-menu__overlay--visible': isMobileMenuOpen }]"
    @click="closeMobileMenu"
  />

  <!-- Mobile Menu -->
  <div :class="['mobile-menu', { 'mobile-menu--open': isMobileMenuOpen }]">
    <button class="mobile-menu__close" @click="closeMobileMenu" aria-label="Close menu">
      &times;
    </button>

    <nav class="mobile-menu__nav">
      <a
        v-for="item in site.nav.menu"
        :key="item.label"
        :href="item.href"
        class="mobile-menu__link"
        @click="closeMobileMenu"
      >
        {{ item.label }}
      </a>

      <hr style="border-color: var(--color-border); margin: 1rem 0;">

      <a
        v-for="link in site.nav.links"
        :key="link.label"
        :href="link.href"
        class="btn btn--primary"
        style="margin-top: 0.5rem;"
        @click="closeMobileMenu"
      >
        {{ link.label }}
      </a>
    </nav>
  </div>
</template>
